module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/busy_animation.77fe3dfeba3960ac9e1a72485d11fd3f.svg";